module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-29b.a8796ea7.png";